<template>
  <div>
    <div class="container text-center">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <form v-on:submit.prevent="validateBeforeSubmit">
            <div class="form-group text-left">
              <label class="custom-label control-label">Please enter Last Name and Date of Birth of child (i.e tanDDMMYY)</label>
              <input class="form-control password-field" type="password" name="password" v-model.trim="password" />
              <span class="error help-block"></span>
            </div>
            <div class="text-danger" v-if="error"><p>Incorrect Password</p></div>
            <button class="btn btn-primary" type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '@/data/datasource'
import Cookies from 'js-cookie'
import { getFormatDate } from '@/helper/utily'

export default {
  data() {
    return {
      error: null,
      password: null,

      encryptedInvName: '',
      encryptedStudID: '',
      isEncrypted: '',
      TotalAmount: '',
      ItemsResp: [],

      ClassName: '',
      PayeeName: '',
      student_Name: '',
      loginType: '',
      ID: '',

      LastName: '',
      DOB: '',
      GeneratePassword: '',
      testResponse: '',
    }
  },
  async mounted() {
    this.ID = decodeURIComponent(this.$route.query.ID)
    this.isEncrypted = 'yes'
    await this.getInfo()
    this.generatePassword()
    this.loginType = Cookies.get('userTypeSession')
  },
  methods: {
    validateBeforeSubmit() {
      if (this.password === this.GeneratePassword) {
        this.error = false
        localStorage.setItem('LoggedUser', 'true')
        localStorage.setItem('LoggedInAt', new Date().toString())
        window.location.replace(`/Public/Payment?ID=${encodeURIComponent(this.ID)}`)
      } else {
        this.error = true
      }
    },
    async getInfo() {
      try {
        const resp = await DataSource.shared.getPaymentGatewayStudentDetail(
          this.encryptedInvName,
          this.encryptedStudID,
          this.TotalAmount,
          this.isEncrypted,
          'invoice',
          this.ID,
        )
        this.testResponse = resp
        if (resp) {
          let StudInfo = []
          StudInfo = resp.Table
          StudInfo.forEach(n => {
            this.ClassName = n.ClassName
            this.student_Name = n.StudentName
            this.PayeeName = n.PayeeName
            this.DOB = n.DOB
          })
        }
      } catch (e) {
        this.errorMsg = e
      }
    },
    generatePassword() {
      let name = this.student_Name.trim()
      this.LastName = name.split(' ')[0].toLowerCase()
      this.GeneratePassword = this.LastName + getFormatDate(this.DOB, 'DDMMYY', 'DD/MM/YYYY HH:mm:ss')
      console.log(this.GeneratePassword)
    },
  },
}
</script>
